import { FC, useCallback } from 'react';

import { Option } from '@beeline/design-system-react/extracted-styles';

import { EmployeeShortInfo } from 'src/api/types';
import {
  PersonAutocomplete,
  toEmployeeShortInfo,
  toPersonOption,
} from 'src/components/PersonAutocomplete/PersonAutocomplete';
import { adminActions } from 'src/store/admin/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

export interface ResponsibleFieldProps {
  id: string;
  value: EmployeeShortInfo | null;
}

export const ResponsibleField: FC<ResponsibleFieldProps> = ({ id, value }) => {
  const dispatch = useAppDispatch();

  const changeResponsible = useCallback(
    (responsible: Option<string>) => {
      dispatch(
        adminActions.update({ responsible: toEmployeeShortInfo(responsible) }),
      );
    },
    [dispatch],
  );

  const clearResponsible = useCallback(() => {
    dispatch(adminActions.update({ responsible: null }));
  }, [dispatch]);

  return (
    <PersonAutocomplete
      type='select'
      key={id}
      value={toPersonOption(value)}
      onChange={changeResponsible}
      dataTestId='employee'
      onInputChange={clearResponsible}
    />
  );
};
